import { type FC } from "react";

import { HealthLogo, PersonalDevelopmentLogo } from "@/components/icons";
import { ChildCard, ComingSoonCard } from "@/components/molecules/ChildCard";

/**
 * NexusApp - landing page for the Nexus workspace
 * Shows available Nexus categories with ChildCards
 *
 * @returns NexusApp component
 *
 */
export const NexusApp: FC = () => {
  return (
    <div className="min-h-screen bg-background p-6 space-y-6 text-primary">
      <header className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <h1 className="text-2xl font-bold">Nexus Workspace</h1>
        </div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Health Card */}
        <ChildCard
          ctaText="View Health Tools"
          description="Monitor your health metrics, sleep quality, activity, and nutrition with integrated health tools."
          icon={<HealthLogo size="app" />}
          title="Health"
          to="/nexus/health"
        />

        {/* Personal Development Card */}
        <ChildCard
          ctaText="View Tools"
          description="Track your personal growth, habits, goals, and self-improvement journey."
          icon={<PersonalDevelopmentLogo size="app" />}
          title="Personal Development"
          to="/nexus/personal-development"
        />

        {/* Future Nexus Tools */}
        <ComingSoonCard
          description="Additional Nexus categories and tools will be available here."
          gradient={{ from: "from-neutral-600", to: "to-neutral-700" }}
          iconLetter="+"
          title="More Categories"
        />
      </div>
    </div>
  );
};
